export var EventOwner;
(function (EventOwner) {
    EventOwner["kindaling"] = "KINDALING";
})(EventOwner || (EventOwner = {}));
//# sourceMappingURL=eventsService.interface.js.map